module.exports = __webpack_public_path__ + "img/20201204_114346.079e28ad.jpg";